module.exports = __webpack_public_path__ + "static/high_bandwidth-abef378e90db6c3758e25e8b5b1503e2.svg";